import { createApiClient } from '../lib/apiClient';

export const DEFAULT_UNIDADES_MODULO = "gestion";
export const CLEANUP_CONFIRMATION_PHRASE = "ELIMINAR OPERATIVA";

const api = createApiClient({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3220",
  headers: { "Content-Type": "application/json" },
});

export const resolveDepositoActual = (deposito) =>
  String(deposito || "").trim().toLowerCase() === "binder2" ? "binder2" : "binder1";

export const mergeDistinctStrings = (...groups) =>
  Array.from(
    new Set(
      groups
        .flat()
        .map((value) => String(value ?? "").trim())
        .filter(Boolean)
    )
  );

export const normalizeStringList = (value) => {
  if (Array.isArray(value)) {
    return mergeDistinctStrings(value);
  }

  if (value === undefined || value === null) {
    return [];
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];

    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return mergeDistinctStrings(parsed);
      }
    } catch (_error) {
      // Compatibilidad con registros viejos guardados como string simple.
    }

    return [trimmed];
  }

  return mergeDistinctStrings(String(value));
};

export const pickFirstStringListValue = (value) => normalizeStringList(value)[0] || "";

export const formatStringList = (value, emptyLabel = "—") => {
  const items = normalizeStringList(value);
  return items.length ? items.join(", ") : emptyLabel;
};

export async function listarUnidadesNegocio({
  deposito,
  modulo = DEFAULT_UNIDADES_MODULO,
}) {
  const { data } = await api.get("/api/unidades-negocio", {
    params: {
      deposito: resolveDepositoActual(deposito),
      modulo,
    },
  });

  return Array.isArray(data) ? data : [];
}

export async function crearUnidadNegocio({
  nombre,
  deposito,
  modulo = DEFAULT_UNIDADES_MODULO,
}) {
  const { data } = await api.post("/api/unidades-negocio", {
    nombre,
    deposito: resolveDepositoActual(deposito),
    modulo,
  });

  return data;
}

export async function editarUnidadNegocio(id, payload = {}) {
  const { data } = await api.put(`/api/unidades-negocio/${id}`, payload);
  return data;
}

export async function eliminarUnidadNegocio(id) {
  const { data } = await api.delete(`/api/unidades-negocio/${id}`);
  return data;
}

export async function limpiarOperativaBinder({
  deposito,
  confirmacion,
}) {
  const { data } = await api.post("/api/configuracion/limpiar-operativa", {
    deposito: resolveDepositoActual(deposito),
    confirmacion,
  });
  return data;
}

export async function obtenerEstadoWhatsapp() {
  const { data } = await api.get("/api/configuracion/whatsapp");
  return data;
}

export async function conectarWhatsapp() {
  const { data } = await api.post("/api/configuracion/whatsapp/conectar");
  return data;
}

export async function desvincularWhatsapp() {
  const { data } = await api.post("/api/configuracion/whatsapp/desvincular");
  return data;
}
